import React, { useState } from 'react'

function getBaseUrl() {
	if (window.location.hostname == 'localhost')
		return ('http://localhost:8081')
	else
		return (window.location.origin);

}

function sendEventToBranch(eventName, extra = {}) {
    try{
      console.log("SENDING PROD Branch EVENT -> 2");
      const user = JSON.parse(localStorage.getItem("user" || "{}")) || '';
      const session = JSON.parse(localStorage.getItem("branch_session_first"));
      let source = "affinity";
     
      const pmEntityId = JSON.parse(localStorage.getItem("corporateID" || "{}")) || '';
      let browserfingerprintId = '';
        return new Promise(async function(resolve, reject) {
          try {
            console.log("SENDING PROD Branch EVENT -> 1");
            window.branch.getBrowserFingerprintId(function(err, data) {
              if(err)
                console.log("error: ", err);
              else
                browserfingerprintId = data;
              let custom_data = {
                appVersion: "",
                patientId: user.id ? user.id : '',
                medibuddyUserId: extra.mediBuddyUserId ? extra.mediBuddyUserId: '',
                browser_fingerprint_id: browserfingerprintId ? browserfingerprintId: "",
                pmEntityId: pmEntityId? pmEntityId: "1018900",
                source: source ? source: "affinity",
                meta: extra.details ? extra.details: "" ,
                sessionId: session ? session.session_id: '',
                type: extra.type? extra.type : "",
                platform: "affinity"
              };
              console.log("SENDING PROD Branch EVENT -> ", custom_data);
              window.branch.logEvent(
                eventName,
                custom_data,
                function(err, data) { 
                  if(err){
                    console.log(err); 
                    reject(err)
                  }else{
                    resolve(data);
                  }
                }
              );
            })
          } catch(err) {
            console.log("Error fetching browser_fingerprint_id: ", err)
            reject(err);
          }
      })
    
    }catch(e){
      console.log(e)
      return e;
    }
  }
 function sendEventToEventLogs(eventName, extra = {}) {
    try{
      console.log("SENDING EVENT -> 2");
      const user = JSON.parse(localStorage.getItem("user" || "{}")) || '';     
      const pmEntityId = JSON.parse(localStorage.getItem("corporateID" || "{}")) || '';
      let browserfingerprintId = '';
          try {
            console.log("SENDING PROD Branch EVENT -> 1");
            window.branch.getBrowserFingerprintId(async function(err, data) {
              if(err)
                console.log("error: ", err);
              else
                browserfingerprintId = data;
              const requestBody={
                "event": eventName,
                "eventType": eventName,
                "user": user.id ? user.id : '',
                "info": extra.mediBuddyUserId ? extra.mediBuddyUserId: '',
                "sessionid": browserfingerprintId ? browserfingerprintId: "",
                "topic": pmEntityId? pmEntityId: "1018900",
                "meta": extra.details ? extra.details: "" ,
                "screen": extra.type? extra.type : "",
                "domain" : 'Affinity',
                "element" : localStorage.getItem('source')
            }
            console.log("SENDING EVENT to eventLogs -> ", requestBody);
            const requestOptions= {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(requestBody)
            };
            const s = await fetch('https://eventlogs.docsapp.in/event',requestOptions).then((t) =>
              t.json()
            )
            console.log(s)
            })
          } catch(err) {
            console.log("Error fetching browser_fingerprint_id: ", err)
            reject(err);
          }
    
    }catch(e){
      console.log(e)
      return e;
    }
  }

  export async function trackBackendEvent({ eventName, eventVersion = '1-0-0', eventData }) {
  try {
    const response = await fetch(`${getBaseUrl()}/patientswebapp/affinity/landingPageEvent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'client': 'affinityWebApp'
      },
      body: JSON.stringify({ eventName, eventVersion, eventData })
    });
    if (!response.ok) {
      console.error('Failed to track event', eventName);
    }
    return response;
  } catch (error) {
    console.error('Error tracking event:', error);
    throw error;
  }
}
  
  export default sendEventToEventLogs
